import 'babel-polyfill';
import {BodyComponent} from "../components/body/body-component";
import {Form} from "../components/form/form";
import {FormField} from "../components/form-field/form-field";
import {FormFieldChecks} from "../components/form-field-checks/form-field-checks";
import {FormFieldDate} from "../components/form-field-date/form-field-date";
import {FormFieldInput} from "../components/form-field-input/form-field-input";
import {FormFieldRadio} from "../components/form-field-radio/form-field-radio";
import {FormFieldSelect} from "../components/form-field-select/form-field-select";
import {FormFieldTextarea} from "../components/form-field-textarea/form-field-textarea";
import {GvfUiService} from "../../gvf/js/gvf-ui-service";
import {FormFieldSelectImage} from "../components/form-field-select-image/form-field-select-image";
import {ModHeader} from "../components/mod-header/mod-header";
import {ModFooter} from "../components/mod-footer/mod-footer";
import {ModOfferNegotiation} from "../components/mod-offer-negotiation/mod-offer-negotiation";
import {ModOfferBookingRefund} from "../components/mod-offer-booking-refund/mod-offer-booking-refund";
import {ModOfferWarrantyRefund} from "../components/mod-offer-warranty-refund/mod-offer-warranty-refund";
import {ModWebUserSetPass} from "../components/mod-web-user-set-pass/mod-web-user-set-pass";
import {FormFieldHtml} from "../components/form-field-html/form-field-html";
import {ModalFormButton} from "../components/modal-form-button/modal-form-button";

GvfUiService.registerComponent(".js-body",BodyComponent);
GvfUiService.registerComponent(".js-form",Form);
GvfUiService.registerComponent(".js-form-field",FormField);
GvfUiService.registerComponent(".js-form-field-checks",FormFieldChecks);
GvfUiService.registerComponent(".js-form-field-date",FormFieldDate);
GvfUiService.registerComponent(".js-form-field-input",FormFieldInput);
GvfUiService.registerComponent(".js-form-field-radio",FormFieldRadio);
GvfUiService.registerComponent(".js-form-field-select",FormFieldSelect);
GvfUiService.registerComponent(".js-form-field-select-image",FormFieldSelectImage);
GvfUiService.registerComponent(".js-form-field-textarea",FormFieldTextarea);
GvfUiService.registerComponent(".js-form-field-html",FormFieldHtml);
GvfUiService.registerComponent(".js-mod-header",ModHeader);
GvfUiService.registerComponent(".js-mod-footer",ModFooter);
GvfUiService.registerComponent(".js-modal-form-button",ModalFormButton);

GvfUiService.registerDelayedComponent(".js-mod-gvml",()=>import("../components/mod-gvml/mod-gvml"));
GvfUiService.registerDelayedComponent(".js-mod-offer-negotiation",()=>import("../components/mod-offer-negotiation/mod-offer-negotiation"));
GvfUiService.registerDelayedComponent(".js-mod-web-user-set-pass",()=>import("../components/mod-web-user-set-pass/mod-web-user-set-pass"));
GvfUiService.registerDelayedComponent(".js-mod-offer-booking-refund",()=>import("../components/mod-offer-booking-refund/mod-offer-booking-refund"));
GvfUiService.registerDelayedComponent(".js-mod-offer-owner-scoring",()=>import("../components/mod-offer-owner-scoring/mod-offer-owner-scoring"));
GvfUiService.registerDelayedComponent(".js-mod-offer-warranty-refund",()=>import("../components/mod-offer-warranty-refund/mod-offer-warranty-refund"));
GvfUiService.registerDelayedComponent(".js-mod-web-user-set-checks-gdpr",()=>import("../components/mod-web-user-set-checks-gdpr/mod-web-user-set-checks-gdpr"));
